import { makeStyles } from "@mui/styles";

const useSelectStyles = makeStyles((theme) => ({
    innerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "0.5px solid",
        borderColor: theme.palette.grey.main,
        width: "60%",
        marginBottom: "3rem",
        paddingBottom: "1rem",
    },
    outerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
    },
    deleteButton: {
        margin: "1rem",
        color: theme.palette.error.main,
    },
}));

export default useSelectStyles;
